// Base
import Image from 'next/image'
import Link from 'next/link'

// Components
import { Box, Flex, Text, Button } from 'yard-utilities/components'
import Section from '@components/v25/section/Section'

import Span from '@components/v21/common/span/Span'

// Styles
import styles from './HowItWorksWrapper.module.sass'

// Data
const data = [
  {
    id: 1,
    title: 'Elige Tu Aeropuerto De Salida',
    description:
      'Selecciona tu aeropuerto de origen y también incluiremos las mejores ofertas de aeropuertos cercanos',
    image: 'deals'
  },
  {
    id: 2,
    title: 'Recibe notificaciones de ofertas por email',
    description: 'Te enviaremos ofertas según tu frecuencia elegida',
    image: 'email'
  },
  {
    id: 3,
    title: 'Reserva La Mejor Oferta',
    description:
      'Obtendrás todos los detalles del vuelo y un enlace de reserva para comprar tus pasajes sin esfuerzo.',
    image: 'departure'
  }
]

interface HowItWorksWrapperProps {
  redirectURL?: string
}

const HowItWorksWrapper = ({
  redirectURL = '/v25/es/membership'
}: HowItWorksWrapperProps) => {
  return (
    <Section padding={[64, 0]}>
      <Text tagName="h2" variant="title-2" spacing={{ sm: 32 }} align="center">
        ¿Cómo Funciona?
      </Text>

      <Flex flexDirection="column" rowGap={{ sm: 24 }} spacing={{ sm: 32 }}>
        {data.map((item) => (
          <HowItWorksCard key={item.id} {...item} />
        ))}
      </Flex>

      <Flex fullWidth justifyContent="center" id="reviews-anchor">
        <Button href={redirectURL} variant="yellow-sm" as={Link}>
          registrarse
        </Button>
      </Flex>
    </Section>
  )
}

export default HowItWorksWrapper

const HowItWorksCard = ({
  title,
  description,
  id,
  image
}: {
  title: string
  description: string
  id: number
  image: string
}) => {
  return (
    <Box
      padding={{ sm: [32, 24, 24] }}
      className={styles.card}
      backgroundColor="white"
      borderRadius={{ sm: [8] }}
    >
      <Box
        backgroundColor="yellow"
        borderRadius={{ sm: [50] }}
        className={styles.tag}
      >
        <Flex center fullHeight fullWidth>
          <Span variant="body-1" fontWeight={700}>
            {id}
          </Span>
        </Flex>
      </Box>
      <Flex flexDirection="column" alignItems="center" rowGap={{ sm: 8 }}>
        <Image
          src={`/images/v25/illustrations/how-it-works/${image}.gif`}
          width={80}
          height={80}
          alt="Illustration"
        />
        <Text
          tagName="h3"
          variant="body-2"
          align="center"
          transform="capitalize"
          fontWeight={700}
        >
          {title}
        </Text>
        <Text tagName="p" variant="body-1" align="center" textColor="grey-2">
          {description}
        </Text>
      </Flex>
    </Box>
  )
}
